/**
 * Disable duplicate atom key during development
 * https://github.com/facebookexperimental/Recoil/issues/733#issuecomment-1399410023
 * */

import { RecoilEnv } from 'recoil'

RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = false
